// vuex store/index.js
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

const PRE_PAGE = 'PRE_PAGE'
const NEXT_PAGE = 'NEXT_PAGE'
const GO_PAGE = 'GO_PAGE'
const state = {
    offset: 0,
    dialogShow: 'hide',
    bodyOverflow: 'static',
    showPerformanceId: 1,
}
const mutations = {
    //上一页
    [PRE_PAGE] (state, offset) {
        state.offset -= offset
    },
    // 分页 下一页
    [NEXT_PAGE] (state, offset) {
        state.offset += offset
    },
    // 分页 跳转到指定页码
    [GO_PAGE] (state, offset) {
        state.offset = offset
    },
    SHOW(state,status) {
        state.dialogShow = status;
    },
    HIDE(state,status) {
        state.dialogShow = status;
    },
    HIDDEN(state,status) {
        state.bodyOverflow = status;
    },
    SCROLL(state,status) {
        state.bodyOverflow = status;
    },
    CHANGEID(state,num) {
        state.showPerformanceId= num;
    }
}
const actions = {
    prePage(context,status) {
        context.commit('PRE_PAGE',status);
    },
    // 分页 下一页
    nextPage(context,status) {
        context.commit('NEXT_PAGE',status);
    },
    // 分页 跳转到指定页码
    goPage(context,status) {
        context.commit('GO_PAGE',status);
    },
    show(context,status) {
		context.commit('SHOW',status);
    },
    hide(context,status) {
        context.commit('HIDE',status);
    },
    hidden(context,status) {
        context.commit('HIDDEN',status);
    },
    scroll(context,status) {
        context.commit('SCROLL',status);
    },
    changeId(context,num) {
        context.commit('CHANGEID',num);
    }
}
export default new Vuex.Store({
    state,
    mutations,
    actions
})


// WEBPACK FOOTER //
// ./src/store/index.js